const URLS = {
  test: {
    js: 'https://testpay.multisafepay.com/sdk/components/v2/components.js',
    css: 'https://testpay.multisafepay.com/sdk/components/v2/components.css',
  },
  live: {
    js: 'https://pay.multisafepay.com/sdk/components/v2/components.js',
    css: 'https://pay.multisafepay.com/sdk/components/v2/components.css',
  },
}

let _promise = null

export function loadMspSdk(env = 'test') {
  if (_promise) return _promise
  if (typeof window !== 'undefined' && typeof window.MultiSafepay === 'function') {
    _promise = Promise.resolve()
    return _promise
  }

  const urls = URLS[env] || URLS.test

  _promise = new Promise((resolve, reject) => {
    const link = document.createElement('link')
    link.rel = 'stylesheet'
    link.href = urls.css
    link.onerror = () => {
      _promise = null
      reject(new Error('MSP SDK failed to load (CSS)'))
    }
    document.head.appendChild(link)

    const script = document.createElement('script')
    script.src = urls.js
    script.async = true
    script.onload = () => resolve()
    script.onerror = () => {
      _promise = null
      reject(new Error('MSP SDK failed to load'))
    }
    document.head.appendChild(script)
  })

  return _promise
}
